<ppl-accordion [title]="'Basic Information'" [isOpen]="true">
  <div class="wiz-body">
    <div>
      @if (pageSource !== 'participantEnrollment' && pageSource !== 'timesheet' && pageSource !== 'invoice')
      {
      <div class="custom-row ppl-mb24" style="font-size: 14px;">
        <ppl-button label="View Auth History" icon="fa fa-eye"
          [customClass]="'ghost-button'" [iconPosition]="'left'"
          (click)="onViewAuthHistory()" [styleString]="'margin-right: 8px;'"></ppl-button>

        @if(mode === "read" && authData?.isDeleted?.toLowerCase() !== 'y' &&
        !isReadOnly){
        <ppl-button label="Edit" icon="fa fa-pencil"
          [customClass]="'ghost-button'" [iconPosition]="'left'"
          (click)="onEdit()" [styleString]="'margin-right: 8px;'"></ppl-button>
        }

        @if(authData?.isDeleted?.toLowerCase() !== 'y' && showDeleteBtn && mode
        === "read" && !isReadOnly && canDeactivateAuthorization()) {
        <ppl-button label="Deactivate Authorization" icon="fa fa-trash"
          [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="onDeleteAuth()"
          [styleString]="'margin-right: 8px;'"></ppl-button>
        }

      </div>
      }

      @if(authData){
      <ppl-auth-forms [formState]="'edit'" [actionMode]="mode"
        [authData]="authData" [from]="'details'"
        [authorizationId]="selectedAuthId" [contextFlow]="flow"
        [disableForm]="disableForm"
        (authUpdate)="onAuthUpdate($event)"></ppl-auth-forms>
      }

    </div>
  </div>
</ppl-accordion>
@if(authData){
<ppl-accordion title="Auth Allocation by Provider" [isOpen]="true">
  <ppl-auth-allocation-list [mode]="pageSource === 'timesheet' || isReadOnly ? true : disableForm" [authData]="authData"
    [consumer]="selectedConsumer"></ppl-auth-allocation-list>
</ppl-accordion>
}
<ppl-accordion title="Additional Details" [isOpen]="true">
  <ppl-auth-additional-details
    [authData]="authData" [contextFlow]="flow"></ppl-auth-additional-details>
</ppl-accordion>
<ppl-accordion title="Documents" [isOpen]="true">
  <ppl-authorization-documents [id]="authData?.authorizationId"
    [readonly]="pageSource === 'timesheet' ? true : isReadOnly"></ppl-authorization-documents>
</ppl-accordion>
<ppl-accordion title="Utilization" [isOpen]="true">
  <ppl-auth-utilization [authData]="authData"></ppl-auth-utilization>
</ppl-accordion>
<ppl-accordion title="Spent Dollar Details" [isOpen]="true">
  <ppl-auth-utilization-line-details [authData]="authData"></ppl-auth-utilization-line-details>
</ppl-accordion>
<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <p> Are you sure you want to deactivate this authorization ?</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #authDialog let-cancel="cancel">
    @if(splitAuthData?.length > 0){
    <ppl-list-table [disableSort]="true" [disableSearch]="true"
      [enableActions]="false" [data]="splitAuthData"
      [disableSelection]="true" [cols]="auth_cols" [gridTitle]="false"
      [pagination]="true" [loadPage]="false">
    </ppl-list-table>
    }
    @else {
    No Data Available
    }
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #authHistoryDialog let-cancel="cancel">
    <ppl-audit-history [auditEntryId]="authData?.authorizationId" [serviceCodes]="serviceCodes"
     [regionalCenters]="regionalCenters" [flow]="'authorization'" [programCode]="programName"></ppl-audit-history>
  </ng-template>
</div>